import { Stack, Typography, useTheme } from '@mui/material';

interface IInfoCardType {
  title: string;
  info: {
    label: string;
    value: string;
  }[];
}

const InfoCard = ({ title, info }: IInfoCardType) => {
  const theme = useTheme();

  return (
    <Stack gap={2}>
      <Typography variant="h6">{title}</Typography>

      <Stack gap={12 / 8}>
        <Stack gap={0.5}>
          {info.map((item) => (
            <>
              <Typography variant="body2" color={theme.palette.text.secondary}>
                {item.label}
              </Typography>
              <Typography variant="body2">{item.value}</Typography>
            </>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default InfoCard;
